import { render } from "./ReporteProveedores.vue?vue&type=template&id=18d25600&scoped=true"
import script from "./ReporteProveedores.vue?vue&type=script&lang=js"
export * from "./ReporteProveedores.vue?vue&type=script&lang=js"

import "./ReporteProveedores.vue?vue&type=style&index=0&id=18d25600&scoped=true&lang=css"

import exportComponent from "/home/runner/work/system-jj-frontend/system-jj-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18d25600"]])

export default __exports__